    tteStatuses = [
      'ТТЕ БЕЗ А/Б 1 ЧЕЛ.',
      'ТТЕ БЕЗ А/Б 2 ЧЕЛ.',
      'ТТЕ БЕЗ А/Б 3 ЧЕЛ.',
      'ТТЕ БЕЗ АВИАБИЛЕТА',
      'ТТЕ ДОКУП А/Б 1 ЧЕЛ.',
      'ТТЕ ДОКУП А/Б 2 ЧЕЛ.',
      'ТТЕ ДОКУП АВИАБИЛЕТА',
      'ТТЕ ЗАПРОС НА А/Б',
      'ТТЕ ПОДТВЕРЖДЕНО',
      'ТТЕ Только А/Б',
      'ТТЕ УВЕДОМЛЕНИЕ SING',
      'ТТЕ БЕЗ Ж/Д',
      'ТТЕ ЗАПРОС А/Б 1 СЕГ',
      'ТТЕ ЗАПРОС А/Б 1 ЧЕЛ',
      'ТТЕ готово к оплате',
      'ТТЕ ГОТОВО К ОПЛАТЕ',
      'ТТЭ ДОКУП А/Б 1 СЕГ',
      'ТТЕ ЗАПРОС НА Ж/Д',
      'ТТЕ ДОКУП Ж/Д',
    ]

    module.exports = tteStatuses
